/** Derive a dynamic fan title from user signals — pure client logic, no DB writes. */
export type FanTitleInput = {
  exactPredictions: number;
  totalPoints: number;
  hypeStreak: number;
  predictionStreak: number;
  referralCount: number;
  shareCount: number;
};

export type FanTitle = {
  key: string;
  emoji: string;
  glow: "amber" | "rose" | "cyan" | "violet" | "lime";
};

const TITLES: Array<{ test: (s: FanTitleInput) => boolean; title: FanTitle }> = [
  { test: (s) => s.exactPredictions >= 5, title: { key: "title_goal_prophet", emoji: "🔮", glow: "violet" } },
  { test: (s) => s.totalPoints >= 50 && s.predictionStreak >= 3, title: { key: "title_tactical_oracle", emoji: "🧠", glow: "cyan" } },
  { test: (s) => s.referralCount >= 4, title: { key: "title_nation_defender", emoji: "🛡️", glow: "amber" } },
  { test: (s) => s.hypeStreak >= 10, title: { key: "title_hype_commander", emoji: "🔥", glow: "rose" } },
  { test: (s) => s.totalPoints >= 100, title: { key: "title_world_cup_legend", emoji: "🏆", glow: "amber" } },
  { test: (s) => s.predictionStreak >= 5, title: { key: "title_pressure_reader", emoji: "🎯", glow: "lime" } },
  { test: (s) => s.shareCount >= 3, title: { key: "title_last_minute_hero", emoji: "⚡", glow: "cyan" } },
];

const DEFAULT: FanTitle = { key: "title_rising_fan", emoji: "🌟", glow: "violet" };

export function resolveFanTitle(input: FanTitleInput): FanTitle {
  for (const t of TITLES) if (t.test(input)) return t.title;
  return DEFAULT;
}